module.exports = __webpack_public_path__ + "static/media/slider-l6.9cfe29c1.webp";